import { render } from "./SysParamDialog.vue?vue&type=template&id=1837142a&scoped=true"
import script from "./SysParamDialog.vue?vue&type=script&lang=js"
export * from "./SysParamDialog.vue?vue&type=script&lang=js"

import "./SysParamDialog.vue?vue&type=style&index=0&id=1837142a&scoped=true&lang=css"

import exportComponent from "D:\\yiban\\WebProject\\yiban-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1837142a"]])

export default __exports__